<app-base-loading-button-modal
  modalTitle="Member Information"
  i18n-modalTitle
  primaryLabel="Continue"
  i18n-primaryLabel
  [isLoading]="isLoading$ | async"
  [hideSecondary]="true"
  [ignoreEscape]="true"
  [hideClose]="true"
  (primaryClicked)="submitForm()">
  <ng-container *ngIf="!(isLoading$ | async); else loading">
    <ng-container *ngIf="formGroup$ | async as form">
      <div [formGroup]="form" class="d-flex flex-column" [style.gap.rem]="2">
        <div class="modal-description" i18n>
          Review the details below. Some information may be updated now, while other changes will require a Change Name
          or Personal Details submission through the member portal once you have access.
        </div>
        <div>
          <div class="form-title" i18n>Personal Information</div>
          <app-member-onboarding-modal-personal-information-form
            [form]="form"
            [formSubmitted]="formSubmitted"
            [pronouns]="pronouns$ | async"
            [genders]="genders$ | async" />
        </div>
        <div>
          <div class="form-title" i18n>Contact Information</div>
          <app-member-onboarding-modal-contact-information-form
            [form]="form"
            [formSubmitted]="formSubmitted"
            [countries]="countries$ | async" />
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div class="form-grid">
      <div *appRepeat="8" class="d-flex flex-column gap-2">
        <lib-loading-shimmer [height]="'1.125rem'" [width]="'3rem'" />
        <lib-loading-shimmer [height]="'3rem'" [width]="'100%'" />
      </div>
    </div>
  </ng-template>
</app-base-loading-button-modal>
